"use client";

import React from "react";
import Label from "@/components/form/Label";
import Input from "@/components/form/input/InputField";

export default function WeightInputPair({
  grossValue,
  tareValue,
  uom = "TON",
  onGrossChange,
  onTareChange,
  error,
  grossId = "gross_w",
  tareId = "tare_w",
}) {
  const g = parseFloat(grossValue) || 0;
  const t = parseFloat(tareValue) || 0;
  const net = g - t;

  return (
    <div className="space-y-3 rounded-lg border border-gray-800 bg-gray-950/50 p-4">
      <div className="grid gap-3 sm:grid-cols-2">
        <div>
          <Label htmlFor={grossId}>Gross Weight</Label>
          <Input
            id={grossId}
            type="number"
            step="0.001"
            value={grossValue}
            onChange={(e) => onGrossChange(e.target.value)}
            className="mt-1"
          />
        </div>
        <div>
          <Label htmlFor={tareId}>Tare Weight</Label>
          <Input
            id={tareId}
            type="number"
            step="0.001"
            value={tareValue}
            onChange={(e) => onTareChange(e.target.value)}
            className="mt-1"
          />
          {error && <p className="mt-1 text-[11px] text-red-400">{error}</p>}
        </div>
      </div>
      <p className="text-sm font-medium text-white">
        Net Weight: {net.toFixed(3)} {uom}
      </p>
    </div>
  );
}
